import {
  Camera,
  Ellipsis,
  ExternalLink,
  List as ListIcon,
  LockKeyhole,
  MapPin,
  Settings,
  Settings2,
  SlidersHorizontal,
  ToggleRight,
  Trash,
  TextAlignJustify,
  EllipsisVertical,
} from "lucide-react";
import { GIFS, IMAGES } from "../constants";

export const BrowserKeyMap = {
  chrome: "Google Chrome",
  safari: "Safari",
  firefox: "Firefox",
  edge: "Microsoft Edge",
  samsung: "Samsung",
  others: "Others",
};

export const REQUIRED_PERMISSIONS = [
  {
    name: "geolocation",
    label: "Location",
    subLabel:
      "Hero FinCorp Instant Personal Loan collects information about the location of your device for risk assessment",
    icon: IMAGES.location,
    mandatory: true,
  },
  // {
  //   name: "camera",
  //   label: "Camera",
  //   subLabel:
  //     "Hero FinCorp Instant Personal Loan will require you to take a selfie to complete the loan application process",
  //   icon: IMAGES.phone,
  //   mandatory: true,
  // },
  {
    name: "notifications",
    label: "Notifications",
    subLabel:
      "With your explicit consent, the Hero FinCorp Instant Personal Loan uses notification permissions for promotions and important loan-related information.",
    icon: IMAGES.notification,
    mandatory: false,
  },
];

export const ICONS_MAP = {
  twoLine: "twoLine",
  threeLine: "threeLine",
  bulletLine: "bulletLine",
  lock: "lock",
  switch: "switch",
  screen: "screen",
  threedot: "threedot",
  externalLink: "externalLink",
  camera: "camera",
  pinlocation: "pinlocation",
  settingWheel: "settingWheel",
  settingline: "settingline",
  deleteBin: "deleteBin",
  EllipsisVertical: "EllipsisVertical",
  radiodot: "radiodot",
  safariscreen: "safariscreen",
  toggleswitch: "toggleswitch",
  threelinesgear: "threelinesgear",
};

export const ICONS = {
  [ICONS_MAP.twoLine]: Settings2,
  [ICONS_MAP.threeLine]: TextAlignJustify,
  [ICONS_MAP.bulletLine]: ListIcon,
  [ICONS_MAP.EllipsisVertical]: EllipsisVertical,
  [ICONS_MAP.lock]: LockKeyhole,
  [ICONS_MAP.switch]: ToggleRight,
  [ICONS_MAP.safariscreen]: IMAGES.safariscreen,
  [ICONS_MAP.threedot]: Ellipsis,
  [ICONS_MAP.externalLink]: ExternalLink,
  [ICONS_MAP.camera]: Camera,
  [ICONS_MAP.pinlocation]: MapPin,
  [ICONS_MAP.settingWheel]: Settings,
  [ICONS_MAP.settingline]: SlidersHorizontal,
  [ICONS_MAP.deleteBin]: Trash,
  [ICONS_MAP.radiodot]: IMAGES.radiodot,
  [ICONS_MAP.toggleswitch]: IMAGES.toggleswitch,
  [ICONS_MAP.threelinesgear]: IMAGES.threelinesgear,
};

export const BROWSER_GUIDE = {
  browsers: {
    "Google Chrome": {
      steps: {
        mobile: {
          ios: [
            [{ type: "text", content: "Click on Settings App" }],
            [{ type: "text", content: "Click on Apps section" }],
            [
              {
                type: "text",
                content: "Search for Chrome in the list of apps",
              },
            ],
            [{ type: "text", content: "Tap on the browser name." }],
            [
              { type: "text", content: "Enable permissions such as" },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: "location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
          ],
          android: [
            [
              { type: "text", content: "Click on" },
              { type: "icon", name: ICONS_MAP.toggleswitch },
            ],
            [
              { type: "text", content: "Click on Permissions" },
              { type: "icon", name: ICONS_MAP.settingline },
            ],
            [
              { type: "text", content: "Allow Permissions for" },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: "location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
          ],
        },
        web: [
          [
            { type: "text", content: "Click on" },
            { type: "icon", name: ICONS_MAP.toggleswitch },
          ],
          [
            { type: "text", content: "Click on Site Settings" },
            { type: "icon", name: ICONS_MAP.externalLink },
          ],
          [
            { type: "text", content: "Allow Permissions for" },
            // { type: "icon", name: ICONS_MAP.camera },
            { type: "text", content: "location" },
            { type: "icon", name: ICONS_MAP.pinlocation },
          ],
        ],
      },
      gifs: {
        mobile: GIFS.permissions.chromemobile,
        ios: GIFS.permissions.chromeiosmobile,
        web: GIFS.permissions.chrome,
      },
    },
    Safari: {
      steps: {
        mobile: {
          ios: [
            [
              { type: "text", content: "Click on" },
              { type: "icon", name: ICONS_MAP.safariscreen },
            ],
            [
              { type: "text", content: "Click on menu" },
              { type: "icon", name: ICONS_MAP.threedot },
            ],
            [
              { type: "text", content: "Allow Permissions for " },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: "location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
          ],
        },
        web: [
          [
            { type: "text", content: "Click on" },
            { type: "icon", name: ICONS_MAP.safariscreen },
          ],
          [
            { type: "text", content: "Click on website setting" },
            { type: "icon", name: ICONS_MAP.settingWheel },
          ],
          [
            { type: "text", content: "Allow Permissions for " },
            // { type: "icon", name: ICONS_MAP.camera },
            { type: "text", content: "location" },
            { type: "icon", name: ICONS_MAP.pinlocation },
          ],
        ],
      },
      gifs: {
        ios: GIFS.permissions.safarimobile,
        web: GIFS.permissions.safari,
      },
    },
    "Microsoft Edge": {
      steps: {
        mobile: {
          android: [
            [
              { type: "text", content: "Click on" },
              { type: "icon", name: ICONS_MAP.threeLine },
            ],
            [
              { type: "text", content: "Click on Setting" },
              { type: "icon", name: ICONS_MAP.settingWheel },
            ],
            [
              { type: "text", content: "Click on Site Setting" },
              { type: "icon", name: ICONS_MAP.threelinesgear },
            ],
            [
              { type: "text", content: "Click on Site Permission" },
              { type: "icon", name: ICONS_MAP.settingWheel },
            ],
            [
              { type: "text", content: "Click on All Sites" },
              { type: "icon", name: ICONS_MAP.bulletLine },
            ],
            [
              {
                type: "text",
                content: "Delete the site loans.herofincorp.com",
              },
              { type: "icon", name: ICONS_MAP.deleteBin },
            ],
            [{ type: "text", content: "Click on Delete and Reset in popup" }],

            [
              { type: "text", content: "Allow Permissions for" },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: "location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
          ],
        },
        web: [
          [
            { type: "text", content: "Click on" },
            { type: "icon", name: ICONS_MAP.lock },
          ],

          [
            { type: "text", content: "Allow Permissions for" },
            // { type: "icon", name: ICONS_MAP.camera },
            { type: "text", content: "location" },
            { type: "icon", name: ICONS_MAP.pinlocation },
          ],
        ],
      },
      gifs: {
        mobile: GIFS.permissions.edgemobile,
        web: GIFS.permissions.edge,
      },
    },
    Firefox: {
      steps: {
        mobile: {
          android: [
            [
              { type: "text", content: "Click on" },
              { type: "icon", name: ICONS_MAP.EllipsisVertical },
            ],
            [
              { type: "text", content: "Click on Setting" },
              { type: "icon", name: ICONS_MAP.settingWheel },
            ],
            [{ type: "text", content: "Click on Site Setting" }],
            [
              { type: "text", content: "Select" },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: " location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
            [
              { type: "text", content: "Select ask to allow" },
              { type: "icon", name: ICONS_MAP.radiodot },
            ],
          ],
        },
        web: [
          [
            { type: "text", content: "Click on" },
            { type: "icon", name: ICONS_MAP.lock },
          ],
          [
            { type: "text", content: "Click on connection secure" },
            { type: "icon", name: ICONS_MAP.lock },
          ],
          [{ type: "text", content: "Click on more information" }],
          [{ type: "text", content: "Click on permission tab" }],
          [{ type: "text", content: "Scroll down to location." }],
          [{ type: "text", content: `Uncheck "Use Default" if checked.` }],
          [{ type: "text", content: `Select "Allow"` }],
        ],
      },
      gifs: {
        mobile: GIFS.permissions.firefoxmobile,
        web: GIFS.permissions.firefox,
      },
    },
    Samsung: {
      steps: {
        mobile: {
          android: [
            [
              { type: "text", content: "Click on" },
              { type: "icon", name: ICONS_MAP.lock },
            ],

            [
              { type: "text", content: "Select" },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: " location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
            [
              { type: "text", content: "Enable the toggle on " },
              { type: "icon", name: ICONS_MAP.switch },
            ],
          ],
        },
      },
      gifs: {
        mobile: GIFS.permissions.samsungbrowser,
      },
    },
    Others: {
      steps: {
        mobile: {
          ios: [
            [{ type: "text", content: "Click on Setting App" }],
            [{ type: "text", content: "Click on Apps Section" }],
            [{ type: "text", content: "Select for your Browser in Apps" }],
            [{ type: "text", content: "Tap on the browser name" }],
            [
              { type: "text", content: "Enable permissions such as " },
              // { type: "icon", name: ICONS_MAP.camera },
              { type: "text", content: "location" },
              { type: "icon", name: ICONS_MAP.pinlocation },
            ],
          ],
        },
        web: [
          [
            {
              type: "text",
              content: "Open your browser’s settings or preferences menu",
            },
          ],
          [
            {
              type: "text",
              content:
                "Look for a section labeled 'Privacy', 'Permissions', or 'Security'",
            },
          ],
          [
            {
              type: "text",
              content: "Find the 'Location' settings or permissions option",
            },
          ],
          [
            {
              type: "text",
              content:
                "Enable location access or choose to be prompted when a site requests your location.",
            },
          ],
          [
            {
              type: "text",
              content:
                "If available, manage site-specific permissions to allow or block location access.",
            },
          ],
        ],
      },
      note: "Note: Settings and steps may vary depending on the browser. Refer to the browser’s official support site for precise instructions.",
      gifs: {
        ios: GIFS.permissions.othermobile,
        web: GIFS.permissions.otherApps,
      },
    },
  },
};

export const getBrowserTabsList = ({ isIos, isMobile }) => {
  const BrowsersList = [
    {
      key: "safari",
      label: "safari",
      icon: IMAGES.safari,
      // hidden: isMobile && !isAppleDevice,
    },
    {
      key: "chrome",
      label: "chrome",
      icon: IMAGES.chrome,
    },
    {
      key: "firefox",
      label: "firefox",
      icon: IMAGES.firefox,
      // hidden: !isMobile,
    },
    {
      key: "samsung",
      label: "samsung",
      icon: IMAGES.samsungbrowser,
      // hidden: !isMobile || (isMobile && !isAppleDevice),
    },
    {
      key: "edge",
      label: "Edge",
      icon: IMAGES.edge,
      // hidden: isIos,
    },
    {
      key: "others",
      label: isMobile ? "Other Browsers" : "Others",
      endIcon: isMobile ? IMAGES.edgebravefirfox : null,
      // hidden: false,
      sx: {
        justifyContent: isMobile ? "space-around" : "center",
        minWidth: "fit-content",
      },
    },
  ];

  const mWeb = new Set(["chrome", "edge", "firefox", "samsung"]);
  const mWebIos = new Set(["chrome", "safari", "others"]);

  if (!isMobile) {
    return BrowsersList?.filter((i) => i.key !== "samsung");
  } else if (isIos) {
    return BrowsersList?.filter((i) => mWebIos.has(i.key));
  } else {
    return BrowsersList?.filter((i) => mWeb.has(i.key));
  }
};
